import projetosEnquadradosService from "@/api/projetos/projetosEnquadrados.service";

export default {
  namespaced: true,

  state: {
    projetos: [],
    loading: false,
    error: null
  },

  getters: {
    all(state) {
      return state.projetos;
    },
  },

  mutations: {
    SET_PROJETOS(state, projetos) {
      state.projetos = projetos;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_PROJETOS_ERROR(state, error) {
      state.error = error;
    },
  },

  actions: {
    async fetchAll({ commit }, clientId) {
       commit('SET_LOADING', true)
       try {
        const response = await projetosEnquadradosService.getAll(clientId);
        commit("SET_PROJETOS", response.data);
       } catch(error) {
        console.error(error)
        commit("SET_PROJETOS_ERROR", error.message);
       } finally {
        commit("SET_LOADING", false);
       }
      
    },  
  }
}